import english from "../assets/images/english.png";
import french from "../assets/images/french.png";
import spanish from "../assets/images/spanish.png";
import portugal from "../assets/images/pt.png";
import arabic from "../assets/images/saudi.png";

/** Must match front-office LanguageSelector codes and API categoryDetails / subCategoryDetails */
export const MENU_LANGUAGE_CODES = [
  "en",
  "fr",
  "de",
  "es",
  "it",
  "pt",
  "ar",
  "zh",
  "ja",
  "ru",
];

/** Flag image (asset URL or https) per menu/client language code — for UI lists (e.g. profile). */
export const MENU_LANGUAGE_FLAG_BY_CODE = {
  en: english,
  fr: french,
  de: "https://flagcdn.com/w40/de.png",
  es: spanish,
  it: "https://flagcdn.com/w40/it.png",
  pt: portugal,
  ar: arabic,
  zh: "https://flagcdn.com/w40/cn.png",
  ja: "https://flagcdn.com/w40/jp.png",
  ru: "https://flagcdn.com/w40/ru.png",
};

/**
 * @param {string} code
 * @returns {string|undefined} Image src URL
 */
export function getMenuLanguageFlag(code) {
  if (code == null) return undefined;
  return MENU_LANGUAGE_FLAG_BY_CODE[String(code).toLowerCase()];
}

/**
 * @param {(key: string) => string} t - i18next t()
 */
export function getMenuLanguages(t) {
  return MENU_LANGUAGE_CODES.map((code) => {
    const flag = MENU_LANGUAGE_FLAG_BY_CODE[code];
    const labelByCode = {
      en: t("english"),
      fr: t("french"),
      de: t("german"),
      es: t("spanish"),
      it: t("italian"),
      pt: t("portugues"),
      ar: t("arabic"),
      zh: t("chinese"),
      ja: t("japanese"),
      ru: t("russian"),
    };
    return { code, label: labelByCode[code] || code, flag };
  });
}
